import Style from "../../../../../Style.module.scss";
import routes from "../../../../../../../utils/routes";
import { useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import { RootState} from "../../../../../../../components/Store";
import { OrderBy as OrderByInner } from "../../../../../../../components/OrderBy";
import {RouteLink} from "../../../../../../../components/RouteLink";

export const OrderBy = (props: {
    radioSlug: string,
    programSlug: string,
    orderBy?: string
}) => {


    const hasUser = useSelector((x:RootState) => x.currentUser);

    const router = useNavigate();

    return <div className={"row mt-24px mb--24px"}>
        <div className={"col-12 align-self-center col-sm-6"}>
            <RouteLink className={`${Style.Href} `} to={routes.radio_program(props.radioSlug)}>
                <span>&lt;</span>&nbsp;&nbsp;&nbsp;Všechny&nbsp;podcasty&nbsp;rádia
            </RouteLink>
        </div>
        { hasUser ? <div className={`col-12 col-sm-6 align-self-center`}><OrderByInner orderBy={props.orderBy} onChange={v =>{
            router(routes.radio_program_detail(props.radioSlug, props.programSlug, v, {}, "episodes" ));
        }} /></div> : false}

    </div>
}